export const environment = {
  production: true,
  version: '1.1.0(0d88cd6)',
  environment: 'production',
  /**
   * 구글 지도 — `nnb-ai-editors` 프로젝트의 `product-draft-maps` 키. 해외 좌표 상품의 지도·지오코딩에만
   * 쓴다(국내는 네이버). **전 스테이지·전 앱이 이 값 하나를 공유한다** — nnb-nextjs 는 SSM
   * `/nnb/nextjs/{test,prod}/`, nnb-partner 는 sst.config 에 같은 값이 있다.
   *
   * 리퍼러 제한으로 보호되는 공개 키라 여기 평문으로 둔다(같은 파일의 KAKAO_AUTH_KEY·portone
   * 키들과 같은 성격). 새 호스트가 생기면 키의 리퍼러 허용목록에도 넣어야 하고, 안 넣으면
   * 구글은 예외를 던지지 않고 **타일만 조용히 안 온다.**
   *
   * mapId 는 AdvancedMarkerElement(커스텀 핀) 렌더에 필요하다.
   */
  googleMaps: {
    apiKey: 'AIzaSyCzxfR1F9pEKbHmz98zHdrDokSmN6PN0O0',
    mapId: '70cd0f6cd9bed2021f8ce40a',
  },
  folder: {
    meeting: 'meetings',
    event: 'events',
    blog: 'blogs',
    banner: 'etc',
    ad: 'ads',
    user: 'users',
    review: 'reviews',
    chat: 'chats',
    feed: 'feeds',
    host: 'hosts',
    hostPrivate: 'host_private',
  },
  KAKAO_AUTH_KEY: 'bc7b219e8b40aae4b2e1745ce1aba555',
  apiDomain: 'https://api.nonunbub.com',
  webDomain: 'https://nonunbub.com',
  payment: {
    prefix: '',
    disabledMethods: ['kakao_pay', 'naver_pay', 'portone_toss_pay'],
  },
  portone: {
    storeId: 'store-80b8452d-9d87-4ba0-9f58-4c4868cd67c8',
    channelKey: 'channel-key-60582f17-1825-42ae-8101-2c69fdbaf80c',
    channelKeyEasyPay: 'channel-key-c02f5d6f-c32c-4375-836f-c648d002f3e7',
    virtualAccountValidHours: 24,
  },
  naverPay: {
    clientId: '9249V_u8L1DHWiyxRMQl',
    mode: 'production',
  },
  kakaoPay: {},
  tospayments: {
    midDefault: 'im_nonunbso38',
    midEasy: 'im_nonunb4k52',
    clientKeyDefault: 'live_ck_ALnQvDd2VJm7pnEWp5dP3Mj7X41m',
    clientKeyEasy: 'live_sk_Poxy1XQL8RJEkgOWyGNY87nO5Wml',
  },
  mixpanelToken: 'b130179c388c57813bd7f504a859c7e6',
};
